import React, { FC } from 'react';
import { Box } from '@mui/material';

interface SingleLogoProps {
  image: {
    src: string;
    alt: string;
  };
  responsive?: boolean;
}

const SingleLogo: FC<SingleLogoProps> = ({ image, responsive = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '10px',
        '& img': {
          maxHeight: '50px !important',
          maxWidth: responsive ? '100%' : '160px', // This fixes the horizontal scroll issue in the nested accordion
          width: responsive ? '100%' : 'auto', // This fixes the horizontal scroll issue in the nested accordion
          height: 'auto',
          objectFit: 'contain',
        },
      }}
    >
      <Box
        component="img"
        src={image.src}
        alt={image.alt}
        sx={{
          maxHeight: '50px',
          maxWidth: '160px',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default SingleLogo;
